"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPickerInputDot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _focusRing = require("../../../../util/focusRing");
var _withFocusClassName = require("../../../../util/withFocusClassName");
var _colorPickerTheme = require("../../colorPickerTheme");
function createFocusRing(_ref) {
  let {
    themeMode
  } = _ref;
  const styles = (0, _focusRing.getFocusRingStyles)({
    theme: themeMode,
    includeFocusPseudoClass: true,
    offset: 6,
    radius: "50%",
    position: "absolute"
  });
  return styles;
}
const ColorPickerInputDot = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("button")`
    width: 24px;
    height: 24px;
    flex: 0 0 24px;
    border-radius: 50%;
    border: 2px solid rgba(17, 17, 17, 0.1);
    box-sizing: border-box;
    cursor: pointer;
    position: absolute;
    top: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _colorPickerTheme.colorPickerTheme.inputDot.top(themeMode);
}};
    left: 8px;

    ${createFocusRing}

    &:hover {
        border-color: currentColor;
    }

    &[aria-disabled="true"] {
        cursor: not-allowed;
    }
`);
exports.ColorPickerInputDot = ColorPickerInputDot;
//# sourceMappingURL=ColorPickerInputDot.js.map